export enum ProspectiveCustomerPartnerQalifiedOptions {
  yes = 'yes',
  manyProducts = 'no - to many products',
  pricesToHigh = 'no - prices to high',
  qualityNotAssured = 'no - quality not assured',
  other = 'no - architect, planning office, etc.',
}
